import { setLoggedIn, setUserAccount } from "api";

import Backdrop from "components/global/Backdrop";
import Button from "components/global/Button";
import ImgWrapper from "components/global/ImgWrapper";
import Spacer from "components/global/Spacer";
import cancel from "assets/icons/cancel_grey.svg";
import check from "assets/icons/check_secondary.svg";
import { connect } from "react-redux";
import exit from "assets/icons/exit.svg";
import plus from "assets/icons/plus_secondary.svg";
import styled from "styled-components";
import { useEffect } from "react";
import { useState } from "react";

const Wrapper = styled(Backdrop)`
  .contentWrapper {
    position: relative;
    padding: 4.8rem 0;
    background-color: #ffffff;
    width: 48rem;
    margin: 5% auto;
    border-radius: 1.6rem;

    @media screen and (min-width: 1440px) {
      margin: 7% auto;
    }
  }

  .header {
    padding: 0 2.4rem;
  }

  .closeBtn {
    position: absolute;
    right: 2.4rem;
    top: 5.6rem;

    .icon {
      height: 2.4rem;
    }
  }

  .divider {
    height: 1px;
    background-color: var(--grey_10);
    margin: 2.4rem 0;
  }

  .btnWrapper {
    padding: 0 2.4rem;

    .noBorder {
      padding: 0;
      height: auto;
    }
  }

  @media screen and (max-width: 768px) {
    .contentWrapper {
      width: 100vw;
      height: 100vh;
      overflow: auto;
      margin: 0;
      border-radius: 0;
      padding: 2.4rem;
      padding-top: 7.2rem;
    }

    .closeBtn {
      top: 2.4rem;
      right: 2.4rem;
    }

    .title {
      font-size: 24px;
      line-height: 32px;
    }
  
    .description {
      font-size: 14px;
      line-height: 20px;
    }
  }
`;

const UserRow = styled.div`
  display: grid;
  grid-template-columns: 4rem auto;
  grid-gap: 1.2rem;
  padding: 2.4rem;
  position: relative;
  cursor: pointer;

  &:hover {
    background-color: var(--background);
  }

  .checkIcon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 2.4rem;
  }
`; 

const Avatar = styled(ImgWrapper)`
  .initials {
    color: #ffffff;
    line-height: 18px;
  }
`;

const SwitchUser = ({ user, setUserAccount }) => {

  const [user_accounts, setUserAccounts] = useState({});

  const handleAddAccount = () => {
    window.location.replace("/sign-in?add_account=true");
  }

  const handleSwitchUser = (email) => {
    setUserAccount(email);
    document.querySelector("#switchUser").classList.remove("show");
  }

  useEffect(() => {
    const user_accounts_storage = localStorage.getItem("user_accounts"); 
    setUserAccounts(user_accounts_storage ? { ...JSON.parse(user_accounts_storage) } : {})

    // eslint-disable-next-line
  }, [])

  return (
    <Wrapper id="switchUser">
      <div className="contentWrapper">
        <button
          className="closeBtn"
          onClick={() =>
            document.querySelector("#switchUser").classList.remove("show")
          }
        >
          <img src={cancel} alt="close" />
        </button>

        <div className="header">
          <h4 className="colorGrey1 title">Switch user</h4>
          <Spacer y={0.6} />
          <p className="colorBodyText l3 description">
            Switch between user accounts.
          </p>
        </div>
        <div className="divider"></div>
        {typeof user_accounts === "object" ? Object.keys(user_accounts).map((key, index) => (
          <UserRow key={index} onClick={() => handleSwitchUser(user_accounts[key]?.email)}>
            <Avatar as="button" bg="var(--primary)" size={4}>
              {user_accounts[key]?.image ? (
                  <img src={`${user_accounts[key].image}`} alt="AVI" />
              ) : (
                  <h5 className="initials textCenter textUppercase">{`${user_accounts[key]?.name
                  ?.split(" ")[0]
                  .charAt(0)}${user_accounts[key]?.name?.split(" ")[1].charAt(0)}`}</h5>
              )}
            </Avatar>
            <div>
              <h6 className="body-2 textCapitalize colorGrey1 truncate">
                  {user_accounts[key]?.name}
              </h6>
              <p className="textDescription colorBodyText truncate">
                  {user_accounts[key]?.email}
              </p>
            </div>
            {user_accounts[key]?.email === user.email ? <img src={check} alt="AVI" className="checkIcon"/> : null}
          </UserRow>
        )) : null}
        <Spacer y={3.6} />
        <div className="btnWrapper">
          <Button text="Add an account" icon={plus} className="noBorder" color="var(--secondary)" onClick={handleAddAccount} />
        </div>
        <div className="divider"></div>
        <div className="btnWrapper">
          <Button text="Logout" icon={exit} className="borderedDanger" onClick={() => setLoggedIn(false)} fullWidth />
        </div>
      </div>
    </Wrapper>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUserAccount: (email) => dispatch(setUserAccount(email)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchUser);
